import React, { useState, useEffect, useCallback, useRef } from 'react';
import { GoogleMap, useJsApiLoader, Polygon } from '@react-google-maps/api';
import blackcar from '../../assets/img/map_car_b.png';
import redcar from '../../assets/img/map_car_r.png';
import greencar from '../../assets/img/map_car_g.png';
import greycar from '../../assets/img/map_car_gr.png';
import * as turf from '@turf/turf';
import moment from 'moment';

const mapStyles = {
  width: '100%',
  height: '87vh',
};

const StolenVehMap = ({ dataToSend, geofenceCoordinates, teleStatus, selectedVehicle }) => {
  const [blackCarCount, setBlackCarCount] = useState(0);
  const [redCarCount, setRedCarCount] = useState(0);
  const [greyCarCount, setGreyCarCount] = useState(0);
  const [greenCarCount, setGreenCarCount] = useState(0);
  const [defaultCenter, setDefaultCenter] = useState({ lat: 51.081467, lng: -113.999875 });
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: 'AIzaSyC36o4niEA5vZG4bMS0CM5FBQaKEt6QADw',
  });
  const [map, setMap] = useState(null);
  const [infoWindow, setInfoWindow] = useState(null); // State for InfoWindow instance

  const convertedDateTime = (dateTime) => {
    return moment(dateTime).tz("US/Eastern").format("MM/DD/YYYY HH:mm")+' EST';
  }

  const onLoad = useCallback((mapInstance) => {
    
    let grey = 0;
    let green = 0;
    let black = 0;
    let red = 0;
    setMap(mapInstance);
    const bounds = new window.google.maps.LatLngBounds();

    const customIcon = {
      url: greencar,
      scaledSize: new window.google.maps.Size(30, 25),
    };
    const customIcon2 = {
      url: redcar,
      scaledSize: new window.google.maps.Size(30, 25),
    };
    const customIcon3 = {
      url: blackcar,
      scaledSize: new window.google.maps.Size(30, 25),
    };
    const customIcon4 = {
      url: greycar,
      scaledSize: new window.google.maps.Size(30, 25),
    };

    // Add markers
    const markerData = dataToSend.vehicle !== 'one_vehicle' ? teleStatus : selectedVehicle;
    let customMarker;
    markerData.forEach((latlong, index) => {
      const googleMapsLink = `https://www.google.com/maps/?q=${latlong.tele_data.geolocation.latitude},${latlong.tele_data.geolocation.longitude}`;
      const v_parking = isInsideGeofence([latlong.tele_data.geolocation.latitude, latlong.tele_data.geolocation.longitude]); // true or false
      const v_state = isInsideGeofenceState([latlong.tele_data.geolocation.latitude, latlong.tele_data.geolocation.longitude]); // true or false
      bounds.extend(new window.google.maps.LatLng(latlong.tele_data.geolocation.latitude, latlong.tele_data.geolocation.longitude));
      if (v_state === false){
        customMarker = customIcon2;
        red = red+1;
      }else if(latlong.current_status === 'In Maintenance'){
        customMarker = customIcon4;
        grey = grey+1;
      }else if(latlong.agreement_type === 'Off Agreement' && v_parking === true){
        customMarker = customIcon3;
        black = black+1;
      }else if(latlong.agreement_type === 'Off Agreement' && v_parking === false){
        customMarker = customIcon2;
        red = red+1;
      }else{
        customMarker = customIcon;
        green = green+1;
      }
      const marker = new window.google.maps.Marker({
        position: { lat: latlong.tele_data.geolocation.latitude, lng: latlong.tele_data.geolocation.longitude },
        map: mapInstance,
        title: `VIN: ${latlong.vin_number}`,
        icon: customMarker,
      });
      marker.addListener('click', () => {
        const contentString = `
          <div>
            <p><b>VIN:</b> ${latlong.vin_number}</p>
            <p><b>Current Status:</b> ${latlong.current_status}</p>
            <p><b>Agreement Number:</b> ${latlong.agreement_number}</p>
            <p><b>Last DateTime:</b> ${convertedDateTime(latlong.tele_data.geolocation.datetime)}</p>
            <p><b>Location:</b> <a href="${googleMapsLink}" target="_blank" rel="noopener noreferrer">View on Google Maps</a></p>
          </div>
        `;  
        // Open new infoWindow
        const newInfoWindow = new window.google.maps.InfoWindow({
          content: contentString,
        });
        newInfoWindow.open(mapInstance, marker);

        // Set selected marker and infoWindow to state
        setInfoWindow(newInfoWindow);
      });
    });
    setBlackCarCount(black);
    setGreenCarCount(green);
    setRedCarCount(red);
    setGreyCarCount(grey);
    const menuList = geofenceCoordinates.state.map(latlong => ({
      lat: latlong[0],
      lng: latlong[1]
    }));
    const menuList2 = geofenceCoordinates.parking.map(latlong => ({
      lat: latlong[0],
      lng: latlong[1]
    }));
    new window.google.maps.InfoWindow({
      content: "contentString",
      ariaLabel: "Uluru",
    });

    // Fit map to bounds
    mapInstance.fitBounds(bounds);
    setDefaultCenter(bounds.getCenter().toJSON());
    
    // Add polygon
    new window.google.maps.Polygon({
      paths: menuList,
      strokeColor: "#6C24D9",
      strokeOpacity: 1,
      fillColor: "#6C24D9",
      fillOpacity: 0.05,
      map: mapInstance,
    });
    new window.google.maps.Polygon({
      paths: menuList2,
      strokeColor: "#2448D9",
      strokeOpacity: 1,
      fillColor: "#2448D9",
      fillOpacity: 0.05,
      map: mapInstance,
    });

  }, [dataToSend, teleStatus, selectedVehicle, geofenceCoordinates]);

  const onCloseInfoWindow = () => {
    if (infoWindow) {
      infoWindow.close();
    }
  };

  if (loadError) {
    return <div>Error loading Google Maps</div>;
  }
  const isInsideGeofence = (position) => {
    if (geofenceCoordinates.parking && geofenceCoordinates.parking.length > 0) {
      // Ensure the polygon is closed by repeating the first coordinate at the end
      const closedGeofenceCoordinates = [...geofenceCoordinates.parking, geofenceCoordinates.parking[0]];
      
      const point = turf.point(position);
      const polygon = turf.polygon([closedGeofenceCoordinates]);
      return turf.booleanPointInPolygon(point, polygon);
    } else {
      return false; // Handle the case where geofenceCoordinates is not properly defined
    }
  };
  const isInsideGeofenceState = (position) => {
    if (geofenceCoordinates.state && geofenceCoordinates.state.length > 0) {
      // Ensure the polygon is closed by repeating the first coordinate at the end
      const closedGeofenceCoordinates = [...geofenceCoordinates.state, geofenceCoordinates.state[0]];
      
      const point = turf.point(position);
      const polygon = turf.polygon([closedGeofenceCoordinates]);
      return turf.booleanPointInPolygon(point, polygon);
    } else {
      return false; // Handle the case where geofenceCoordinates is not properly defined
    }
  };
  return isLoaded ? (
    <div>
      <GoogleMap
        mapContainerStyle={mapStyles}
        zoom={3}
        center={defaultCenter}
        onLoad={onLoad}
        onClick={onCloseInfoWindow}
      />
    </div>
  ) : (
    <div>Loading...</div>
  );
};

export default StolenVehMap;
